import { render, staticRenderFns } from "./AllRolesTable.vue?vue&type=template&id=3fdbd2c0&scoped=true&"
import script from "./AllRolesTable.vue?vue&type=script&lang=js&"
export * from "./AllRolesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllRolesTable.vue?vue&type=style&index=0&id=3fdbd2c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbd2c0",
  null
  
)

export default component.exports